<template>
    <div class="app">
        <Loading :value="loading"></Loading>

          <v-dialog v-model="dialogReglementCarte" max-width="70%" persistent fullscreen hide-overlay>
      <v-card >
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
              <span > Liste des règlements de la carte {{carte.identifiant}}  </span>
           
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
              <v-layout row >
                <v-card style="width:100%">
                    <v-card-text fluid grid-list-md>
                    <h6>LISTE DES REGLEMENTS </h6>
                    <v-divider class="mb-3" ></v-divider>
                    
                    <!-- BTN AJOUT -->
                    <v-layout row>
                           <v-flex class="mb-1 " xs4 md4>
                            <v-card-text class="text-xs-center">
                                <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:100%">
                                    <span class="subheading">Solde Total: </span>  <span class="title"> {{mntTotal}} Fcfa </span> 
                                </v-chip>
                            </v-card-text>
                           </v-flex>

                           <v-flex class="mb-1 " xs4 md4 >
                                <v-card-text class="">
                                <v-chip color="orange" text-color="white" style="font-size:18px">
                                <v-avatar  class="orange darken-4">{{nbRgt}}</v-avatar>
                                Règlement(s)
                            </v-chip>
                             </v-card-text>
                           </v-flex>
                    </v-layout>  
                   
   
                    <div class="text-xs-right mb-3" >
                      <v-tooltip top>
                        <v-btn  slot="activator" icons color="primary" @click.stop="modalAjoutRgt()" dark>Ajouter un règlement <v-icon right>playlist_add</v-icon></v-btn>
                        Ajouter un règlement
                      </v-tooltip>

                      <!-- <v-tooltip top>
                            <v-btn :disabled="true"  slot="activator" color="orange"  @click.stop="imprimeRgtPDF()" >
                                Imprimer
                                <v-icon right > print</v-icon>
                            </v-btn>
                            Imprimer la liste des règlements
                        </v-tooltip> -->
                    </div>

                     <v-layout row >
                   
                    </v-layout>
                   

                     
                     <!-- <div class="text-xs-left  mb-1 " >
                         <el-select clearable @clear="clearSelect()"  @change="filtrerRgt" v-model="selectRgt" placeholder="Trier par station">
                                <el-option
                                        v-for="item in reglements"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id">
                                </el-option>
                            </el-select>

                     </div> -->
                    
                    <data-tables :data="reglements" >
                        <el-table-column prop="dateRgt" label="date" > </el-table-column>
                        <el-table-column prop="type" label="Mission/Chantier" ></el-table-column>
                        <el-table-column prop="montantFormat" label="Solde (Fcfa)" >
                        <template slot-scope="scope">
                            <el-tag >  {{scope.row.montantFormat}}</el-tag>
                        </template>
                        </el-table-column>
                        <el-table-column prop="createdUser" label="Enregistré par" > </el-table-column>
                         <el-table-column prop="updateUser" label="Modifié par" > </el-table-column>
                        <el-table-column prop="description" label="Description" > </el-table-column>
                        <el-table-column label="Action" align="center" fixed="right"  >
                        <template slot-scope="scope">
                           
                            <v-tooltip top>
                            <v-btn  slot="activator" @click.stop="modalEditRgt(scope.row)"  fab dark small color="primary">
                                <v-icon dark>edit</v-icon>
                                </v-btn>
                                    Editer
                            </v-tooltip>

                            <!-- <v-tooltip top>
                            <v-btn :disabled="true" slot="activator" @click.stop=""  fab  small color="orange">
                                <v-icon dark>print</v-icon>
                                </v-btn>
                                    Imprimer
                            </v-tooltip> -->

                            <!-- <v-tooltip top>
                                <v-btn  slot="activator" @click.stop="deleteRgt(scope.row)" fab dark small color="red">
                                    <v-icon dark>delete</v-icon>
                                </v-btn>
                                Supprimer
                            </v-tooltip> -->
                        </template>
                        </el-table-column>
                    </data-tables>
                  </v-card-text>
                </v-card>
            </v-layout>

            <!-- MODAL SUPPRESSION DEMANDE -->
        <v-dialog v-model="dialogSupr" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
        <v-card-text>
            <v-layout wrap>
                <v-flex xs12 class="mb-2">
                     <el-alert
                        title="La suppression est définitive"
                        :closable="false"
                        show-icon
                        type="error">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">REGLEMENTS</p>
                    <p class="black--text .font-weight-regular subheading" >ID-{{idRgt}}</p>
                </v-flex>
            </v-layout>
            
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1"  dark @click="dialogSupr = false">Annuler <v-icon right>remove_circle</v-icon></v-btn>
          <v-btn color="red darken-1" dark  @click="deleteDmd()">Supprimer <v-icon right>delete</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- MODAL SUPPRESSION DEMANDE -->
        </v-card-text>
      </v-card>
    </v-dialog>
    
    
            <!-- Ajout zone maintenance -->
            <AjoutReglementCarte :editRgt="editRgt" :carte="carte" :show="showModalAjoutRgt" @close="showModalAjoutRgt = false;loadReglement()" ></AjoutReglementCarte>
            <!-- Ajout zone maintenance -->

    </div>
</template>

<script>

    import AjoutReglementCarte from './AjoutReglementCarte'
    
   
    import Loading from '@/components/Loading'
    export default {
        components:{ Loading,AjoutReglementCarte},
        name: "ReglementCarteIndex",
        props:{
            show:{
                type: Boolean,
                required: true
            },
            carte:{
                type: Object,
                //required: true
            }
        },
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,
                // racourcis: [
                //     { path: '/', text: 'Accueil', disabled: false },
                //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
                // ],

                reglements: [],
                oldReglements: [],
                dialogSupr: false,
                dialogReglementCarte: false,
                selectRgt:'',
                editRgt: {},
                idRgt:null,
             
                
                showModalAjoutRgt: false,
                nbRgt: 0,
                mntTotal:0
               
            }
        },

        watch:{
            show: function(newValue,oldValue)
            {
                this.dialogReglementCarte = newValue;
                if(newValue == true){
                    this.loadReglement();
                }
            }
        },

        methods: {
            deleteRgt(rgt){
                this.idRgt = rgt.id
                this.dialogSupr =true;
            },
            closeDialog(){
                this.$emit("close");
            },

            modalAjoutRgt(){
                this.editRgt = {};
                this.showModalAjoutRgt = true;
            },

              modalEditRgt(reglement){
                  this.editRgt = reglement;
                this.showModalAjoutRgt = true;
            },

        imprimeRgtPDF()
        {
            let tab = [];
            this.reglements.forEach(function(reglement) {
                 tab.push(reglement.id)
            });

              let  url = this.domaine+"carteCarburant/reglement/imprimerPDF/liste/"+tab 
             window.open(url)
  
        },

            
      


            // deleteDmd () 
            // {
            //       this.loading = true
                  
            //         let url = this.domaine + 'demandeFond/delete/' + this.itemDmd.id
            //         this.$http.get(url).then(response => {
            //              this.loading = false
                    
            //             this.$notify({
            //                 title: 'SUPPRESSION',
            //                 message: 'Demande supprimée avec succès.',
            //                 type: 'success',
            //                 position: 'top-center'
            //             })
            //             this.dialogSupr = false
                        
            //             this.loadDemande ()
            //             }, errRep => {
            //                    this.loading = false
            //                    this.dialogSupr = false
            //                 this.$notify.error({
            //                 title: 'SUPPRESSION ECHOUEE',
            //                 message: 'La suppression de la demande a échouée.',
            //                 position: 'top-center'
            //             })
            //             })
            // },

         
            clearSelect(){
               this.reglements = this.oldReglements
            },

            filtrerRgt(idRgt){

            },
             loadReglement()
             {
                 //this.loading = true;
                
                 //afficher que les carte que l'utilisateur a creer
                 //if(this.droitAcces.liste_demande_fond)
                  
                let url = this.domaine +  'carteCarburant/reglement/carte/'+this.carte.carteId;
                 
              this.$http.get(url ).then(response => {
                  //this.loading = false;
                  console.log("reglements")
                  console.log(response.body)
                 // this.mntTTC =  response.body.mntTTC
                  this.reglements = response.body.reglements
                  this.oldReglements= response.body.reglements
                  this.nbRgt = this.reglements.length;
                 
                  this.mntTotal = response.body.montantTotalFormat
                  //affichage nombre de demande
                  if(response.body.reglements > 0){
                      this.nbRgt = this.reglements.length
                  }
                  
                },
                error => {
                    this.loading = false;
                     this.$message.error("Une erreur est survenue lors du chargement de la liste des règlements")

                })
            },
            
        },

        mounted() 
        {
            //this.loadReglement();
        }
    };
</script>

<style scoped>
    .toolbar_content {
        height:37px; 
    }
</style>



// WEBPACK FOOTER //
// src/components/carteCarburant/ReglementCarteIndex.vue